export default "__VITE_ASSET__DosHFu0V__"